import Blog01 from './01.jpg';
import Blog02 from './02.jpg';
import Blog03 from './03.jpg';
import Blog04 from './04.jpg';
import Blog05 from './05.jpg';
import Blog06 from './06.jpg';
import Blog07 from './07.jpg';
import Blog08 from './08.jpg';

export { Blog01, Blog02, Blog03, Blog04, Blog05, Blog06, Blog07, Blog08 };
